import { z } from "zod";
import { customEnumErrorHandler } from "./util";

export const ChallengeNameSchema = z.enum(
  [
    "oneHourWarrior",
    "doubleDown",
    "tripleTrouble",
    "quad",
    "8Ball",
    "theBig12",
    "1Day",
    "trueSimp",
    "bigramSalad",
    "simp",
    "simpLord",
    "antidiseWhat",
    "whatsThisWebsiteCalledAgain",
    "developd",
    "slowAndSteady",
    "speedSpacer",
    "iveGotThePower",
    "accuracyExpert",
    "accuracyMaster",
    "accuracyGod",
    "inAGalaxyFarFarAway",
    "beepBoop",
    "whosYourDaddy",
    "itsATrap",
    "jolly",
    "gottaCatchEmAll",
    "rapGod",
    "navySeal",
    "littleChef",
    "crosstalk",
    "bees",
    "getOffMySwamp",
    "lookAtMeIAmTheDeveloperNow",
    "beLikeWater",
    "rollercoaster",
    "oneHourMirror",
    "chooChoo",
    "mnemonist",
    "earfquake",
    "simonSez",
    "accountant",
    "hidden",
    "iCanSeeTheFuture",
    "whatAreWordsAtThisPoint",
    "iKiNdAlIkEhOwInEfFiCiEnTqWeRtYiS",
    "specials",
    "aeiou",
    "asciiWarrior",
    "oneNauseousMonkey",
    "thumbWarrior",
    "mouseWarrior",
    "mobileWarrior",
    "69",
    "upsideDown",
    "oneArmedBandit",
    "englishMaster",
    "feetWarrior",
    "wingdings",
  ],
  {
    errorMap: customEnumErrorHandler("Must be a known challenge name"),
  },
);

export type ChallengeName = z.infer<typeof ChallengeNameSchema>;
